import { useAsyncFn as useAsyncFnReactUse } from 'react-use';

// see https://github.com/streamich/react-use/blob/master/src/useAsyncFn.ts
export const useAsyncFn: typeof useAsyncFnReactUse = (
  fn,
  deps = [fn], // this is different than react-use
  initialState,
) => useAsyncFnReactUse(fn, deps, initialState);
